// extracted by mini-css-extract-plugin
export default {"section":"taskspanel_section__ksJT1","form":"taskspanel_form__oExHc","list":"taskspanel_list__MHj8x","timeToComplete":"taskspanel_timeToComplete__2HkKH"};